/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaTagIcon/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TysiaTagIcon({
  children,
  viewPath = "/DesignSystem/TysiaTag/TysiaTagIcon",
  marginRight = 2,
  marginLeft = 0,
  fill,
  type,
  style
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsBlue900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.900'
        })
let dtColorsOrange700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.700'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtColorsRed700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.700'
        })
let fillOrdtColorsNeutral600 = fill ?? dtColorsNeutral600
let fillOrdtColorsNeutral6001 = fill ?? dtColorsNeutral600
  return (<React.Fragment
>
<Children
  viewPath={`${viewPath}/Children`}
 width={12}
 height={12}
 marginRight={marginRight}
 marginLeft={marginLeft}
 fill={type === "grey" && style === "filled" ? dtColorsWhite : type === "blue" && style === "filled" ? dtColorsBlue900 : type === "orange" && style === "filled" ? dtColorsWhite : type === "green" && style === "filled" ? dtColorsWhite : type === "red" && style === "filled" ? dtColorsWhite : type === "grey" ? dtColorsNeutral600 : type === "blue" ? dtColorsBlue900 : type === "orange" ? dtColorsOrange700 : type === "green" ? dtColorsGreen700 : type === "red" ? dtColorsRed700 : fillOrdtColorsNeutral6001}
>
{children}
</Children>
</React.Fragment>)
}